import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import dot from 'dot-object';
import clonedeep from 'lodash.clonedeep';
import router from '@/router';
import statuses from '@/store/statuses';
import store from '@/store';
import { VTN } from '@/store/types';

// let singleDomain = false;
// if (typeof ENV.VUE_APP_API_SAMEDOMAIN === 'undefined') {
//   const req = new XMLHttpRequest();
//   req.open('HEAD', window.location.origin, false);
//   req.setRequestHeader('IsSingleDomain', '1');
//   req.send(null);
//   singleDomain = req.getResponseHeader('X-SingleDomain');
// } else {
//   singleDomain = ENV.VUE_APP_API_SAMEDOMAIN === 'true'
//     || ENV.VUE_APP_API_SAMEDOMAIN === 'TRUE'
//     || ENV.VUE_APP_API_SAMEDOMAIN === true;
// }

// if (singleDomain) {
axios.defaults.baseURL = `${window.location.origin}`;
// } else {
//   console.warn('specifying differnet backend api domain is unupported, contact developer!');
//   axios.defaults.baseURL = location.protocol.includes('https') ? ENV.VUE_APP_API_HTTPS : ENV.VUE_APP_API_HTTP;
// }

const Backend = axios.create();
const backendAbortControllers = new Map()

Backend.interceptors.request.use(async (req) => {
  if (req.tokenOverride) req.headers.common['Authorization'] = `Bearer ${req.tokenOverride}`;
  if (req.public) return req;
  if (!req.tokenOverride
    && !req.public
    && !store.getters['Auth/tokenValid'](50)
    && store.getters['Auth/refreshTokenValid'](60)) {
    // try {
    const token = await store.dispatch(VTN.REFRESH_AUTH_TOKEN); // .then((token) => {
    req.headers.common['Authorization'] = `Bearer ${token}`;
  }

  if (req.cancelDuplicates) {
    if (backendAbortControllers.has(req.url)) {
      const signal = backendAbortControllers.get(req.url)
      signal.abort()

      backendAbortControllers.delete(req.url)
    }
    const ab = new AbortController()
    req.signal = ab.signal
    backendAbortControllers.set(req.url, ab)
  }

  return req;
});

Backend.interceptors.response.use((response) => {
  const serverResponse = response.data;

  if (backendAbortControllers.has(response.config.url)) {
    backendAbortControllers.delete(response.config.url)
  }

  if (response.headers['content-type'] !== 'application/json') {
    return Promise.resolve({
      data: serverResponse,
      headers: response.headers,
    });
  }
  if (Vue.oflineChck) Vue.oflineChck().setPinged(true);

  switch (response.status) {
    case 200:
      return Promise.resolve({
        data: serverResponse,
        headers: response.headers,
        status: statuses.LOADED,
        when: Date.now()
      });

    case 201:
      return Promise.resolve({
        data: serverResponse,
        headers: response.headers,
        status: statuses.LOADED,
        when: Date.now()
      });

    default:
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        data: serverResponse,
        headers: response.headers,
        status: statuses.ERROR,
        when: Date.now()
      });
  }
}, (error) => {
  if (!error.response) {
    console.warn('error in try catch block of network request!', error);
    return Promise.reject({ data: error, headers: {}, status: statuses.ERROR });
  }
  let errors = {};
  let message = null;
  if (typeof error.response !== 'undefined') {
    switch (error.response.status) {
      case 401:
        store.dispatch(VTN.LOGOUT);
        break;
      case 403:
        // TODO
        if (!error.response.config.noForbidden) {
          console.log('Forbidden error', error.response.config);
          router.replace({ name: 'Forbidden' }).catch(() => {});
        }
        break;
      case 422:
        console.log('Validation error');
        if (error.response.data) {
          errors = clonedeep(error.response.data.errors);
          dot.object(errors);
          message = error.response.data.message;
        }
        break;

      default:
        console.log('Error');
      // TODO
    }
  }

  const headers = error.response ? error.response.headers : {};
  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject({
    data: error.response,
    headers: headers,
    status: statuses.ERROR,
    errors: errors,
    message: message,
    when: Date.now()
  });
});

const buildFormData = function (formData, data, parentKey) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    let value = data == null ? '' : data;
    if (typeof value === 'boolean') value = value ? 1 : 0;
    // if (value === null) value = 'NULL';
    formData.append(parentKey, value);
  }
};

const filenameFilter = (filename) => {
  return filename.replace(/[/\\?%*:|"<>]/g, '-');
};

const forceDownload = (response, title) => {
  const contentDisposition = response.headers['content-disposition'];
  const match = contentDisposition.match(/filename\s*=\s*("(?<fn1>.+)"|(?<fn2>[^;]*))/i);
  const filename = match.groups.fn1 || match.groups.fn2 || 'unknown';

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  console.log(response, filename);
  link.href = url;
  link.setAttribute('download', title || filename);
  document.body.appendChild(link);
  link.click();
};

const newTabDownload = (response) => {
  const file = new Blob([response.data], { type: response.headers['content-type'] });
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL);
};

const download = (data, title) => {
  Backend({ method: 'get', url: '', ...data, responseType: 'arraybuffer' })
    .then((response) => {
      if (data.newTab) {
        newTabDownload(response, title);
      } else {
        forceDownload(response, title);
      }
    })
    .catch((err) => console.log('error occured', err));
};

Vue.use(VueAxios, Backend);
export { axios, Backend, download, filenameFilter, buildFormData };
